<div class="d-flex align-items-center help" style="padding: 20px; gap: 12px;">    
    <ng-content select="[helpIcon]"></ng-content>
    <ng-content select="[helpDesc]"></ng-content>
</div>